<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <i-card-vertical headerTitle="해지 신청 관리" device="web" :IsUseEditorBox="true">
        <template v-slot:EditorBox>
          <v-row no-gutters>
            <v-col class="d-flex justify-space-between align-center">
              <v-switch v-model="allYn">
                <template v-slot:label>
                  <span style="margin-left: 5px;">{{ allYn ? '전체' : '미완료' }}</span>
                </template>
              </v-switch>
            </v-col>
          </v-row>
        </template>

        <template v-slot:body>
          <DxDataGrid
            id="cancelDataGrid"
            class="layout-col-height00"
            :ref="dxDataGridRef"
            :data-source="gridMain"
            :remote-operations="false"
            :hover-state-enabled="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            :show-borders="true"
            :show-row-lines="true"
            :selection="{ mode: 'single' }"
            key-expr="orderId"
            :focused-row-enabled="true"
          >
            <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

            <DxColumn data-field="clntId" data-type="string" :visible="false"></DxColumn>
            <DxColumn data-field="compId" data-type="string" :visible="false"></DxColumn>
            <DxColumn data-field="constructNm" data-type="string" :visible="false"></DxColumn>
            <DxColumn data-field="writeDt" data-type="string" :visible="false"></DxColumn>
            <DxColumn data-field="docNo" data-type="string" :visible="false"></DxColumn>

            <DxColumn
              data-field="save"
              data-type="string"
              width="100px"
              alignment="center"
              caption
              :allow-editing="false"
              cell-template="actionTemplete"
            ></DxColumn>
            <template #actionTemplete="{ data: cellInfo }">
              <div>
                <v-btn color="primary" elevation="0" dark small @click="btnDetail(cellInfo)" class="rounded px-3 grid-btn">상세보기</v-btn>
              </div>
            </template>
            <DxColumn data-field="clntNm" data-type="string" width="120px" alignment="center" caption="고객사명" :allow-editing="false" />
            <DxColumn data-field="constructNm" data-type="string" width="250px" alignment="center" caption="사업장(공사)명" :allow-editing="false" />
            <template #dateTemplate="{ data: cellInfo }">
              <div>{{ cellInfo.data.cancelRequestAt }}</div>
            </template>
            <DxColumn
              data-field="cancelRequestAt"
              data-type="string"
              alignment="center"
              caption="해지요청일"
              width="230px"
              :allow-editing="false"
              cell-template="dateTemplate"
            />
            <DxColumn data-field="cancelReason" data-type="string" alignment="center" caption="해지사유" width="250px" :allow-editing="false" />
            <DxColumn
              data-field="cancelAmount"
              data-type="string"
              alignment="right"
              caption="환불금액"
              width="150px"
              :allow-editing="false"
              cell-template="amountCellTemplate"
            />
            <DxColumn
              data-field="cancelStatus"
              data-type="string"
              alignment="center"
              caption="상태"
              width="110px"
              :allow-editing="false"
              cell-template="cancelApprovalTemplate"
            />
            <template #cancelApprovalTemplate="{ data: cellInfo }">
              <div :style="getStatusStyle('cancelList', cellInfo.data.cancelStatus)">{{ getStatusNm('cancelList', cellInfo.data.cancelStatus) }}</div>
            </template>
            <DxColumn data-field="cancelAt" data-type="string" alignment="center" caption="해지 완료일" width="230px" :allow-editing="false" />
           
            <template #amountCellTemplate="{ data: cellInfo  }">
              <div>{{ formatToKoreanWon(cellInfo.value) + '원' }}</div>
            </template>
          </DxDataGrid>
        </template>
      </i-card-vertical>
      <i-card-right headerTitle :useBtnList="buttonUseList" @btnSearch="btnSearch(true)"></i-card-right>
    </v-sheet>
  </v-container>
</template>

<script>
// 컴포넌트
import iCardVertical from '@/components/common/iCardVertical.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'

// API
import { getCompManage, saveCompManage } from '@/api/sojunganManagement/compMange'
import { getCommonCode } from '@/api/common/commonApi'
import { getCancelManage } from '@/api/adminManagement/cancelManage'

export default {
  mixins: [baseview, BaseDataGrid],
  name: 'compManage',
  components: {
    'i-card-vertical': iCardVertical
  },
  data() {
    return {
      dxDataGridRef: 'companyDataGrid',
      companyUseYn: true,
      gridMain: [],
      valid: true,
      buttonUseList: [
        'btnSearch' //조회
      ],
      allMode: 'allPages',
      cancelList: [],
      allYn: true,
      allYnList: [
        {text: '전체', value: true},
        {text: '미완료', value: false},
      ]
    }
  },
  watch: {
    allYn() {
      this.btnSearch(true)
    },
    companyUseYn() {
      this.btnSearch(true)
    }
  },
  computed: {},
  beforeMount() {},
  created() {
    // 승인 / 결제 / 해지 단계 공통코드 조회
    Promise.all([getCommonCode('CM018')]).then(res => {
      this.cancelList = res[0].list
    })
  },
  activated() {
    const allYn = this.$route.params?.allYn
    if (allYn !== undefined && allYn !== this.allYn) {
      // 필터 변경 시 allYn watcher에서 조회한다.
      this.allYn = allYn
    } else {
      // 메뉴 재진입 시에도 현재 조회 조건으로 목록을 갱신한다.
      this.btnSearch(true)
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      if (date.indexOf('-') == -1) {
        const year = date.substring(0, 4)
        const month = date.substring(4, 6)
        const day = date.substring(6, 8)
        return `${year}.${month}.${day}`
      } else if (date.indexOf('-') > -1) {
        const [year, month, day] = date.split('-')
        return `${year}.${month}.${day}`
      } else {
        return date
      }
    },
    formatToKoreanWon(value) {
      const numberValue = parseFloat(value.replace(/,/g, ''))
      if (!isNaN(numberValue)) {
        return numberValue.toLocaleString('ko-KR')
      }
    },
    getStatusStyle(dataList, status) {
      // 진행상태에 따라 스타일 부여
      let style = 'color:#B4B4B4;'
      let statusCd = this[dataList].find(el => el.minorCd === status)
      if (statusCd) {
        switch (statusCd.minorCd) {
          case 'N':
            style = `color:#B4B4B4;`
            break
          case 'R':
            style = `color:#FF2D2D;`
            break
          case 'A':
            style = `color:#1B53F3;`
            break
        }
      }
      return style
    },
    getStatusNm(dataList, status) {
      let statusCd = this[dataList].find(el => el.minorCd === status)
      if (statusCd) return statusCd.minorNm
      else return '-'
    },
    //------------------------------------------
    //  해지목록 조회
    //------------------------------------------
    async btnSearch(isNotify) {
      this.openLoading('searching')

      let params = {allYn: this.allYn ? 'Y': 'N'}

      // origin
      /*getCancelManage({}).then(res => {
        console.log(res)
        if (res.success) {
          this.gridMain = res.list
        }
      })*/
      try {
        const response = await getCancelManage(params, isNotify)
        if(response.success) {
          this.gridMain = response.list || []
        } else {
          this.gridMain = []
        }
      } catch(error) {
        console.error('getCancelManage error catch >> ', error)
        this.gridMain = []
      } finally {
        this.endLoading()
      }

      this.endLoading()
    },
    //------------------------------------------
    //  해지 상세페이지 이동
    //------------------------------------------
    async btnDetail(cellInfo) {
      console.log('##########', cellInfo)
      const toRouter = {
        name: 'CancelManageDetail',
        params: {
          data: cellInfo.data
        }
      }
      this.$router.push(toRouter)
    }
  }
}
</script>

<style scoped></style>
